<template>
	<div id="wrapper">
		<SidebarView :reports="true" />
		<div class="d-flex flex-column" id="content-wrapper">
			<div id="content">
				<TopbarView />
				<div class="container-fluid">
					<div class="card card-shape home-box">
						<div class="card-header">
							<div class="row align-items-center">
								<div class="col-6">
									<h6 class="m-0 fw-bold text-green">
										RECEIPTS AND PAYMENTS SUMMARY
									</h6>
								</div>
								<div class="col-6 text-end">
									<b-button @click="generateExcel"
										class="btn-sm me-2 akkurate-green-btn akkurate-small">
										<font-awesome-icon :icon="['fas', 'file-excel']" />
									</b-button>
									<report-filter :form="form" @filterAction="getBalanceSheets" :filter="filter"
										:current_financial_year="financial_year
											">
									</report-filter>
									<b-button @click="printPDF" class="btn-sm me-2 akkurate-green-btn akkurate-small"
										title="Print">
										<font-awesome-icon :icon="['fas', 'print']" />
									</b-button>
									<b-button @click="downloadPDF" class="btn-sm akkurate-green-btn akkurate-small"
										title="Download">
										<font-awesome-icon :icon="['fas', 'download']" />
									</b-button>
								</div>
							</div>
						</div>
						<div class="card-body">
							<div class="row" ref="pdfContent">
								<div class="col-12 col-md-12">
									<statement-institution :institution="institution" :current_date="false"
										:title="'RECEIPTS AND PAYMENTS SUMMARY'"></statement-institution>
								</div>
								<hr />
								<div class="row mb-2">
									<div class="col-12 small">
										Branch(es) : {{ branch_list_display }}
									</div>
								</div>
							</div>

							<div class="row">
								<div class="col-md-8"></div>
								<div class="col-md-4 text-end">
									<div>
										Terms:
										<span class="fw-bold">{{
											form.terms
										}}</span>
									</div>
									<span style="font-weight: bold" v-if="form.start_date && form.end_date">From: {{
										form.start_date }} to
										{{ form.end_date }}</span>
								</div>
							</div>
							<div v-if="isBusy" class="text-center text-danger my-2">
								<b-spinner class="align-middle"></b-spinner>
								<strong>Loading...</strong>
							</div>
							<div v-else id="receipt-payment-summary" class="row mx-1">
								<div class="col-12 p-0 fw-bold my-2">
									RECEIPTS AND PAYMENTS
								</div>
								<div class="col-6 col-md-6 trans_details px-0">
									<b-table-simple bordered responsive outlined>
										<b-thead>
											<b-tr variant="secondary">
												<b-th class="text-center fs-6 py-1"
													colspan="2"><span>Receipts</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<!-- Loop through COA heads for receipts -->
											<template v-for="(coa_type, index) in coa_heads">
												<b-tr>
													<td class="py-0 px-2 fw-bold">
														{{ coa_type?.type_name }}
													</td>
												</b-tr>
												<b-tr v-for="(coa_head, idx) in coa_type?.coa_heads"
													:key="idx + coa_head?.display_name">
													<td class="py-0 px-2">
														{{ coa_head?.display_name }}
													</td>
													<td class="py-0 px-2">
														{{ institution?.currency_code }} {{
															displayNumber(coa_head?.total_receipts) }}
													</td>
												</b-tr>
												<b-tr variant="success">
													<td class="py-0 px-2 fw-bold">
														TOTAL
													</td>
													<td class="py-0 px-2 fw-bold">
														{{ institution?.currency_code }} {{
															displayNumber(coa_type?.total_receipts) }}
													</td>
												</b-tr>
											</template>
										</b-tbody>
										<b-tfoot>
											<b-tr>
												<b-th>Total Receipts</b-th>
												<b-th>{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_receipts).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Total Income</b-th>
												<b-th>{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_incomes).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th colspan="2">Profit/ Loss</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
								<div class="col-6 col-md-6 trans_details px-0">
									<b-table-simple bordered responsive outlined>
										<b-thead>
											<b-tr variant="secondary">
												<b-th class="text-center fs-6 py-1"
													colspan="2"><span>Payments</span></b-th>
											</b-tr>
										</b-thead>
										<b-tbody>
											<!-- Loop through COA heads for payments -->
											<template v-for="(coa_type, index) in coa_heads">
												<b-tr>
													<td class="py-0 px-2 fw-bold">
														{{ coa_type?.type_name }}
													</td>
												</b-tr>
												<b-tr v-for="(coa_head, idx) in coa_type?.coa_heads"
													:key="idx + coa_head?.display_name">
													<td class="py-0 px-2">
														{{ coa_head?.display_name }}
													</td>
													<td class="py-0 px-2">
														{{ institution?.currency_code }} {{
															displayNumber(coa_head?.total_payments) }}
													</td>
												</b-tr>
												<b-tr variant="danger">
													<td class="py-0 px-2 fw-bold">
														TOTAL
													</td>
													<td class="py-0 px-2 fw-bold">
														{{ institution?.currency_code }} {{
															displayNumber(coa_type?.total_payments) }}
													</td>
												</b-tr>
											</template>

										</b-tbody>
										<b-tfoot>
											<b-tr>
												<b-th>Total Payments</b-th>
												<b-th>{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_payments).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th>Total Expenses</b-th>
												<b-th>{{ institution?.currency_code }}
													{{
														displayNumber(
															Number(total_expenses).toFixed(2)
														)
													}}</b-th>
											</b-tr>
											<b-tr>
												<b-th colspan="2">{{
													displayNumber(
														Number(difference).toFixed(2)
													)
												}}</b-th>
											</b-tr>
										</b-tfoot>
									</b-table-simple>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<footer></footer>
		</div>

		<!-- AI -->
		 <ChatBot />
		<!-- End AI -->
		<a class="d-inline scroll-to-top" href="#page-top"><i class="fas fa-angle-up"></i></a>
	</div>
</template>
<script>
import SidebarView from "@/views/main/components/Sidebar.vue";
import TopbarView from "@/views/main/components/Topbar.vue";
import Footer from "@/views/main/components/Footer.vue";
import StatementInstitution from "@/views/main/components/institution/StatementInstitution.vue";
import ApiService from "@/core/services/api.service";
import Multiselect from "vue-multiselect";
import html2pdf from "html2pdf.js";
import ReportFilter from "@/views/main/pages/reports/form/ReportFilter.vue";
import ExcelJS from "exceljs";
import ChatBot from "@/views/components/AI/ChatBot.vue";
export default {
	components: {
		SidebarView,
		TopbarView,
		Footer,
		StatementInstitution,
		Multiselect,
		ReportFilter,
		ChatBot,
	},
	data() {
		return {
			financial_year: null,
			filter: {
				branches: true,
				products: false,
				users: false,
				status: false,
				condition: false,
				coa: false,
				terms: true,
				start_date: true,
				end_date: true,
				loan_status:false,
			},
			current_financial_year: {},
			form: {
				start_date: this.getOneMonthEailer(),
				end_date: new Date().toISOString().split('T')[0],
				branches: [],
				products: [],
				branch_options: [],
				product_options: [],
				users: [],
				users_options: [],
				status: [],
				coa: [],
				coa_options: [],
				terms: "Periodic",
				terms_options: ["YTD", "Periodic"],
				categories: [],
				loan_status:[],
			},
			receipts: [],
			payments: [],
			search: "Search",
			isBusy: false,
			isSearching: false,
			selected_num: "10",
			numbers_options: [10, 50, 100, 500],
			isLoadingInstitution: false,
			institution: "",
			start_date: "",
			end_date: "",
			perPage: 20,
			currentPage: 1,
			items: [],
			coa_heads: [],
			total_receipts: 0,
			total_payments: 0,
			net_cash_flow: 0,
			total_shares_dp: 0,
			total_savings_dp: 0,
			total_loan_repayment: 0,
			total_shares_with: 0,
			total_savings_with: 0,
			total_loan_disbursed: 0,
			total_bank_savings_wd: 0,
			total_bank_current_wd: 0,
			total_bank_savings_dp: 0,
			total_bank_current_dp: 0,
			total_cff_wd: 0,
			total_t_bill_discount: 0,
			total_other_receipt: 0,
			total_cff_dp: 0,
			total_t_bill_invest: 0,
			total_other_payments: 0,
			grand_total_receipt: 0,
			grand_total_payment: 0,
			total_incomes: 0,
			total_expenses: 0,
			difference: 0,
		};
	},
	computed: {
		rows() {
			return this.items.length;
		},
		sumLoanBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].loan_balance;
			}
			return total;
		},
		sumSavingBalance() {
			let total = 0;
			for (let i = 0; i < this.items.length; i++) {
				total = this.items[i].saving_balance;
			}

			return total;
		},
		//assets total
		sumAssetsTotal() {
			let total = 0;
			for (let i = 0; i < this.assets_items.length; i++) {
				total = this.assets_items[i].amount;
			}
			return total;
		},
		branch_list_display() {
			const selected = this.form.branches || [];
			const all = this.form.branch_options || [];

			if (selected.length > 0) {
				return selected.map(b => b.name).join(", ");
			}
			if (all.length > 0) {
				return all.map(b => b?.name).join(", ");
			}
			return "";
		},
	},

	created() {
		this.getInstitution();
		this.getBalanceSheets();
		this.getProductDropdown();
	},
	methods: {
		filterAction() {
			// this.changePerPageNumber(this.perPage);
			// this.form.start_date =
			this.getBalanceSheets();
		},
		async getBalanceSheets() {
			this.items = [];
			this.isBusy = true;
			this.search = "Processing...";
			this.isSearching = true;
			await ApiService.post(
				"/reports/financials/receipts-payments/default",
				{
					start_date: this.form.start_date,
					end_date: this.form.end_date,
					terms: this.form.terms,
					branches: this.form.branches.map(index => index?.id ?? []),
				}
			)
				.then((response) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					var res = response.data;
					console.log(res);

					// Set the new data structure
					this.coa_heads = res.grouped_coa || [];
					this.total_receipts = res.total_receipts || 0;
					this.total_payments = res.total_payments || 0;
					this.net_cash_flow = res.net_cash_flow || 0;
					this.total_incomes = res.grant_monthly_total_incomes || 0;
					this.total_expenses = res.grant_monthly_total_expenses || 0;

					this.difference = this.total_incomes - this.total_expenses || 0
				})
				.catch((error) => {
					this.isBusy = false;
					this.search = "Search";
					this.isSearching = false;
					console.log(error);
				});
		},

		downloadPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
				})
				.save();
		},
		async getProductDropdown() {
			this.isBusy = true;
			this.search = "Processing...";
			await ApiService.query("/reports/controls/products/dropdown")
				.then((response) => {
					// console.log(response.data);
					this.isBusy = false;
					this.search = "Search";
					this.form.branch_options = response.data.branches;
					this.form.product_options = response.data.products;
					this.form.coa_options = response.data.coa_subheads;
				})
				.catch((error) => {
					// console.log(error);
					this.isBusy = false;
					this.search = "Search";
				});
		},

		async generateExcel() {
			const fileUrl = "/REPORT_TEMPLATE_NEW.xlsx";
			const imageUrl = "/default_logo.png";

			const institutionName = this.institution.name || '';
			const institutionMotto = this.institution.motto || '';
			const institutionAddress = this.institution.address || '';
			const institutionPhone = this.institution.telephone || '';
			const institutionEmail = this.institution.email || '';
			const date = "FROM: " + this.form.start_date + " TO: " + this.form.end_date;
			const terms = "TERMS: " + this.form.terms;

			try {
				const response = await fetch(fileUrl);
				if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
				const arrayBuffer = await response.arrayBuffer();

				const wb = new ExcelJS.Workbook();
				await wb.xlsx.load(arrayBuffer);
				const ws = wb.getWorksheet(1);

				// Add image if available
				try {
					const imageResponse = await fetch(imageUrl);
					if (imageResponse.ok) {
						const imageBuffer = await imageResponse.arrayBuffer();
						const imageId = wb.addImage({ buffer: imageBuffer, extension: "png" });
						ws.addImage(imageId, { tl: { col: 0, row: 0 }, ext: { width: 300, height: 200 } });
					}
				} catch (imageError) {
					console.warn("Could not load image:", imageError);
				}

				// Institution details
				const startRow = 1;
				ws.getCell(`L${startRow}`).value = institutionName;
				ws.getCell(`L${startRow}`).font = { bold: true, size: 14 };
				ws.getCell(`L${startRow + 1}`).value = institutionAddress;
				ws.getCell(`L${startRow + 1}`).font = { size: 12 };
				ws.getCell(`L${startRow + 2}`).value = institutionMotto;
				ws.getCell(`L${startRow + 2}`).font = { size: 12 };
				ws.getCell(`L${startRow + 3}`).value = institutionPhone;
				ws.getCell(`L${startRow + 3}`).font = { size: 12 };
				ws.getCell(`L${startRow + 4}`).value = institutionEmail;
				ws.getCell(`L${startRow + 4}`).font = { size: 12 };
				ws.getCell(`L${startRow + 6}`).value = date;
				ws.getCell(`L${startRow + 6}`).font = { size: 12 };
				ws.getCell(`L${startRow + 7}`).value = terms;
				ws.getCell(`L${startRow + 7}`).font = { size: 12 };
				ws.getCell(`L${startRow + 8}`).value = "Branch(es): " + this.branch_list;
				ws.getCell(`L${startRow + 8}`).font = { size: 12 };
				ws.getColumn("L").width = 50;

				// Headers for Receipts and Payments
				const headerRowNum = 13;
				const headerRow = ws.getRow(headerRowNum);
				headerRow.font = { bold: true };
				ws.mergeCells(headerRowNum, 1, headerRowNum, 2);
				ws.mergeCells(headerRowNum, 3, headerRowNum, 4);
				ws.getCell(headerRowNum, 1).value = "Receipts";
				ws.getCell(headerRowNum, 1).alignment = { horizontal: "center" };
				ws.getCell(headerRowNum, 3).value = "Payments";
				ws.getCell(headerRowNum, 3).alignment = { horizontal: "center" };
				headerRow.commit();

				let currentRowNum = headerRowNum + 1;

				// Loop through coa_heads (each coa_type)
				for (const coaType of this.coa_heads) {
					// COA Type row for Receipts and Payments
					const typeRow = ws.getRow(currentRowNum);
					typeRow.getCell(1).value = coaType.type_name || '';
					typeRow.getCell(1).font = { bold: true };
					typeRow.getCell(3).value = coaType.type_name || '';
					typeRow.getCell(3).font = { bold: true };
					typeRow.commit();
					currentRowNum++;

					// Loop through coa_heads inside this coa_type
					for (const coaHead of coaType.coa_heads) {
						const row = ws.getRow(currentRowNum);
						row.getCell(1).value = coaHead.display_name || '';
						row.getCell(2).value = Number(coaHead.total_receipts || 0).toFixed(2);
						row.getCell(3).value = coaHead.display_name || '';
						row.getCell(4).value = Number(coaHead.total_payments || 0).toFixed(2);
						row.commit();
						currentRowNum++;
					}

					// Subtotal row for this coa_type
					const subtotalRow = ws.getRow(currentRowNum);
					subtotalRow.getCell(1).value = "TOTAL";
					subtotalRow.getCell(1).font = { bold: true };
					subtotalRow.getCell(2).value = Number(coaType.total_receipts || 0).toFixed(2);
					subtotalRow.getCell(2).font = { bold: true };
					subtotalRow.getCell(3).value = "TOTAL";
					subtotalRow.getCell(3).font = { bold: true };
					subtotalRow.getCell(4).value = Number(coaType.total_payments || 0).toFixed(2);
					subtotalRow.getCell(4).font = { bold: true };
					subtotalRow.commit();
					currentRowNum++;
				}

				// Grand totals row
				const grandTotalRow = ws.getRow(currentRowNum);
				grandTotalRow.getCell(1).value = "Total Receipts";
				grandTotalRow.getCell(1).font = { bold: true };
				grandTotalRow.getCell(2).value = Number(this.total_receipts || 0).toFixed(2);
				grandTotalRow.getCell(2).font = { bold: true };
				grandTotalRow.getCell(3).value = "Total Payments";
				grandTotalRow.getCell(3).font = { bold: true };
				grandTotalRow.getCell(4).value = Number(this.total_payments || 0).toFixed(2);
				grandTotalRow.getCell(4).font = { bold: true };
				grandTotalRow.commit();

				// Set column widths
				ws.getColumn(1).width = 30; // Receipt description
				ws.getColumn(2).width = 15; // Receipt amount
				ws.getColumn(3).width = 30; // Payment description
				ws.getColumn(4).width = 15; // Payment amount

				const now = new Date();

				const pad = (num) => num.toString().padStart(2, '0');

				// Generate and download Excel file
				const buffer = await wb.xlsx.writeBuffer();
				const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
				const link = document.createElement("a");
				link.href = URL.createObjectURL(blob);
				link.download = `Receipt_and_Payment_Summary_${this.form.start_date}_to_${this.form.end_date}.xlsx`;
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(link.href);

			} catch (err) {
				console.error("Error generating Excel file:", err);
				this.$bvToast.toast('Failed to generate Excel file. Please try again.', {
					title: 'Export Error',
					variant: 'danger',
					solid: true
				});
			}
		},

		printPDF() {
			const content = this.$refs.pdfContent; // Reference to the HTML content you want to convert
			// console.log("here");
			const pdfOptions = {
				margin: [0.5, 0.2, 0.8, 0.2], //top, left, buttom, right
				filename: "statement.pdf",
				image: { type: "jpeg", quality: 0.98 },
				html2canvas: { scale: 2 },

				jsPDF: {
					unit: "in",
					format: "letter",
					orientation: "portrait",
				},
			};
			html2pdf()
				.from(content)
				.set(pdfOptions)
				.toPdf()
				.get("pdf")
				.then((pdf) => {
					var totalPages = pdf.internal.getNumberOfPages();
					var insit_name = this.institution.name;
					var insit_tele = this.institution.telephone;
					var insit_email = this.institution.email;
					var insit_motto = this.institution.motto;

					for (var i = 1; i <= totalPages; i++) {
						pdf.setPage(i);
						pdf.setFontSize(8);
						pdf.setTextColor(150);
						pdf.text(
							[
								"For Inquiries, Please Contact " +
								insit_name +
								", Customer Service on " +
								insit_tele +
								"",
								"or email us on " +
								insit_email +
								" " +
								insit_motto +
								"",
								"Page " + i + " of " + totalPages,
							],
							pdf.internal.pageSize.getWidth() / 2,
							pdf.internal.pageSize.getHeight() - 0.6,
							{ align: "center" }
						);
					}
					// Get the blob of the PDF
					return pdf.output("blob");
				})
				.then((pdfBlob) => {
					// Create a URL for the PDF blob
					var pdfUrl = URL.createObjectURL(pdfBlob);

					// Open the URL in a new tab
					const printWindow = window.open(
						pdfUrl,
						"_blank",
						"width=800,height=600"
					);
					printWindow.onload = () => {
						printWindow.print();
						URL.revokeObjectURL(pdfUrl);
					};
				})
				.catch((error) => {
					console.error("Error generating PDF:", error);
				});
		},
		filterAction() {
			this.changePerPageNumber(this.perPage);
		},
		changePerPageNumber(data) {
			if (data == "All") {
				this.perPage = this.items.length;
				this.getCustomerProduct();
			} else {
				this.perPage = data;
				this.getCustomerProduct();
			}
		},
		async getInstitution() {
			this.isLoadingInstitution = true;
			await ApiService.get("/settings/institution")
				.then((response) => {
					this.institution = response.data.data;
				})
				.catch((error) => {
					console.log(error);
				})
				.finally(() => {
					this.isLoadingInstitution = false;
				});
		},
	},
};
</script>